import $http from "../../http";
let execute_response = require("./mqtt_instruct").execute_response;
let execute_request =  require("./mqtt_instruct").execute_request;
var TOP = "02", END = "03"; // 内容头尾

var mqtt_ack_request = 0,   // MQTT请求
  mqtt_ack_response = 1;  // MQTT响应

var mqtt_encrypt_not = 0,   //  MQTT不加密
  mqtt_encrypt_aes = 1;   //  MQTT AES加密

var mqtt_confirm_nwait = 0,      // 发送期待应答
  mqtt_confirm_wait = 1,     // 发送不期待应带
  mqtt_confirm_success = 2,   // 应答成功
  mqtt_confirm_fail = 3;      // 应答失败

var mqtt_cd_module = 0,     // 模块命令
  mqtt_cd_cmd = 1,        // 服务器命令
  mqtt_cd_data = 2,       // 服务器数据流
  mqtt_cd_api = 3;        // API数据流

var mqtt_qos_0 = 0,
  mqtt_qos_1 = 1;

var mqtt_processor_innner = 0,      // MQTT协议处理器 前端处理内容部分
  mqtt_proccessor_web_all = 1,    //  MQTT协议处理器 前端处理全部
  mqtt_processor_server_all = 2;  // MQTT协议处理器 服务器处理全部

var X0160_lbsloc = "0:0160", // 获取定位信息
  X0161_siminfo = "0:0161", // 获取Sim卡信息

  X0140_real_report = "1:0140",// 实时汇报
  X0400_sensor = "1:0400",//传感器信息

  API_DATA = "3:";// 数据参数

var DEFAULT_RESPONSE = {
    device: {
        directory: "",
        identify: ""
    },
    processor: 0,
    request: false,
    confirm: 0,
    cd: 0,
    command: "",
    content: ""
};

/**
 * MQTT 协议
 * @type {{assemble: (function(*=, *=, *=, *=): *), assemble_mark: mqtt_protocol.assemble_mark, assembleContent: mqtt_protocol.assembleContent}}
 */
var mqtt_protocol = {
    /****************************************组装部分***************************************/
    /**
     * MQTT前端组装协议[暂不封装完成]
     * @param qos   级别
     * @param processor 处理器
     * @param encrypt   加密方式
     * @param request   通讯方式
     * @param confirm   确认等级
     * @param cd    指令类型
     * @param command   指令
     * @param imqtt_arrs 对象
     */
    assemble_pack: function (qos, processor, encrypt, request, confirm, cd, command, imqtt_arrs, encoding) {
        request = typeof request === 'number' ? request === mqtt_ack_request : request;
        if (processor === mqtt_processor_innner) {
            return this.pack_sub_publish(qos, encrypt, request, confirm, cd, command, imqtt_arrs, encoding)
        } else if (processor === mqtt_proccessor_web_all) {
            return {}
        } else {
            return {}
        }
    },
    /**
     * Proccessor = 1 前端负责内部协议组装
     * @param qos   级别
     * @param processor 处理器
     * @param encrypt   加密方式
     * @param request   通讯方式
     * @param confirm   确认等级
     * @param cd    指令类型
     * @param command   指令
     * @param imqtt_arrs 对象
     */
    pack_sub_publish: function (qos, encrypt, request, confirm, cd, command, imqtt_arrs, encoding) {
        request = typeof request === 'number' ? request === mqtt_ack_request : request;
        return {
            qos: 0,
            encrypt: encrypt,
            request: request,
            confirm: confirm,
            cd: cd,
            command: command,
            content: execute_request(cd, request, command, imqtt_arrs, encoding)
        }
    },
    /****************************************解析部分***************************************/
    /**
     * Websocket 接受信息解析
     * {
     * @param qos   级别
     * @param processor 处理器
     * @param encrypt   加密方式
     * @param request   通讯方式
     * @param confirm   确认等级
     * @param cd    指令类型
     * @param command   指令
     * @param imqtt_arrs 对象
     * }
     */
    parse_unpack: function (response, encoding) {
        if (response.processor === mqtt_processor_innner) {
            return this.unpack_sub_publish(response, encoding)
        } else if (response.processor === mqtt_proccessor_web_all) {
            return {}
        } else {
            return {}
        }
    },
    /**
     * Proccessor = 1 前端负责内部协议组装
     * @param cmd
     * @param content
     */
    unpack_sub_publish: function (response, encoding) {
      // debugger
        var result = execute_response(response.cd, response.request, response.command, response.content, encoding);
        response.result = result;
        return response;
    },
};
export default mqtt_protocol;
// module.exports = {
//   mqtt_protocol:mqtt_protocol
// }



//////////////////
// WEBPACK FOOTER
// ./api/agreement/mqtt-agreement/mqtt_protocol.js
// module id = null
// module chunks = 